import type { NavItem } from '../types'

export const HEADER_LINKS: NavItem[] = [
  {
    aria: 'Lore',
    name: 'Lore',
    link: 'loriet',
    theme: 'lore'
  }, 
  {
    aria: 'RJ',
    name: 'RJ',
    link: 'rj',
    theme: 'heart'
  },
]
